import root from "window-or-global";
import moment from "moment-mini";
import {
  type StorageConfig,
  type StorageSetOptions,
  type StoredValue,
} from "../types/logic";

export default class Storage {
  prefix: string;

  constructor({prefix}: StorageConfig = {}) {
    this.prefix = prefix || "";
  }

  set = (
    key: string,
    value: unknown,
    options: StorageSetOptions = {
      expires: {
        length: 1,
        period: "day",
      },
    }
  ): Storage => {
    const k = `${this.prefix}${key}`;
    const v: StoredValue = {
      value,
    };

    if (options.expires) {
      const {length, period} = options.expires;
      v.expires = moment().add(length, period).toISOString(true);
    }

    this.getStorage().setItem(k, JSON.stringify(v));
    return this;
  };

  get = (key: string): unknown => {
    const k = `${this.prefix}${key}`;
    const v = this.getStorage().getItem(k);

    if (v && v !== "") {
      const item = JSON.parse(v) as StoredValue;
      if (item.expires && item.expires !== "") {
        if (moment(item.expires).isAfter(moment())) {
          return item.value;
        }
        this.getStorage().removeItem(k);
        return undefined;
      }
      return item?.value;
    }
    return undefined;
  };

  del = (key: string): void => {
    const k = `${this.prefix}${key}`;
    this.getStorage().removeItem(k);
  };

  getStorage = (): globalThis.Storage => {
    return root.localStorage as globalThis.Storage;
  };
}

export const AuthStorage = new Storage({prefix: "auth"});

